export const getQueryParam = (name) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};
export const getQueryUrl = () => {
  return window.location.pathname;
};
